import { CircularProgress, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import feedbackService from "../../../api/FeedbackService";
import {
  BiggerThanSmallAndSmallerThanMediumText,
  SmallText,
} from "../../../common/styles/Text.styles";
import {
  borderStyle,
  smallerGap,
  smallGap,
} from "../../../styles/consts";
import { formatUnixTimestamp } from "../../../utils";
import ScoresInCommentPanel from "../ScoresInCommentPanel";

// Define Comment interface locally
interface Comment {
  id?: string;
  message: string;
  created_at: string;
  created_by: string;
  createdTimestamp?: string;
  username?: string;
  rating?: any;
  feedback?: any;
}

export default function CommentsPanel({
  displayedMatchId,
  refreshTrigger = 0,
}) {
  const [loading, setLoading] = useState(true);
  const [comments, setComments] = useState<Comment[]>([]);
  useEffect(() => {
    const fetchComments = async () => {
      if (displayedMatchId) {
        setLoading(true);
        const fetchedComments = await feedbackService.getComments(
          displayedMatchId
        );
        setComments(fetchedComments);
      }

      setLoading(false);
    };

    fetchComments();
  }, [displayedMatchId, refreshTrigger]);
  return (
    <Stack sx={{ paddingBottom: smallerGap }}>
      {loading ? (
        <Stack
          sx={{
            width: "100%",
            height: "100%",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Stack>
      ) : comments.length > 0 ? (
        comments.map((comment, index) => (
          <Stack
            key={comment.createdTimestamp}
            sx={{
              padding: smallerGap,
              borderBottom: borderStyle,
            }}
          >
            <Stack
              sx={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Stack
                sx={{
                  flexDirection: "row",
                  gap: smallGap,
                  alignItems: "center",
                }}
              >
                <BiggerThanSmallAndSmallerThanMediumText>
                  {comment.username}
                </BiggerThanSmallAndSmallerThanMediumText>
                {comment.rating && (
                  <ScoresInCommentPanel rating={comment.rating} />
                )}
              </Stack>
              <SmallText>
                {comment.createdTimestamp ? formatUnixTimestamp(comment.createdTimestamp.toString()) : ""}
              </SmallText>
            </Stack>
            {comment.feedback && (
              <Typography sx={{ whiteSpace: "pre-line" }}>
                {comment.feedback.trim()}
              </Typography>
            )}
          </Stack>
        ))
      ) : (
        <Typography>No comments for this match yet.</Typography>
      )}
    </Stack>
  );
}
